import React from 'react';

// Polite live region for route changes (WCAG 4.1.3). It must stay mounted across
// navigations (a region inserted together with its text is often not announced), so
// AppLayout renders it unconditionally and only the message changes.
const RouteAnnouncer = ({ message }) => (
  <div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
    {message}
  </div>
);

export default RouteAnnouncer;
